var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMovieLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.5,28H6.5V24.888H3.25V28H0V0H3.25V3.111H6.5V0h13V3.111h3.25V0H26V28H22.749V24.888H19.5V28ZM9.75,3.23V24.769h6.5V3.23ZM19.5,18.307v3.23h3.25v-3.23Zm-16.25,0v3.23H6.5v-3.23ZM19.5,12.922v3.231h3.25V12.922Zm-16.25,0v3.231H6.5V12.922ZM19.5,6.462v3.23h3.25V6.462Zm-16.25,0v3.23H6.5V6.462Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMovieLibrary);
export default __webpack_public_path__ + "static/media/icon-movie-library.5eede2a8de1689fc7f5d3ea94764e0af.svg";
export { ForwardRef as ReactComponent };